export default __webpack_public_path__ + "static/media/hoodie.3e5e4876.svg";